import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useToast } from "@/components/ui";
import { sendQueuedAdds } from "@/lib/queries";

/**
 * Sends what quick add saved without signal: when the app opens, when the signal is back and
 * when you come back to the app (an answer lost mid-request leaves the movement queued online).
 */
export function useOfflineSync(): void {
  const qc = useQueryClient();
  const toast = useToast();
  useEffect(() => {
    const send = () => {
      if (!navigator.onLine) return;
      void sendQueuedAdds(qc)
        .then(({ saved, rejected }) => {
          if (saved.length === 1) toast("Ya se guardó lo que agregaste sin señal");
          else if (saved.length > 1) toast(`Ya se guardaron ${saved.length} movimientos sin señal`);
          for (const { input, message } of rejected)
            toast(`No se guardó «${input.description}»: ${message}`, "error");
        })
        .catch(() => {
          /* IndexedDB unavailable (private mode): nothing was queued */
        });
    };
    const onVisible = () => {
      if (document.visibilityState === "visible") send();
    };
    send();
    window.addEventListener("online", send);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.removeEventListener("online", send);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [qc, toast]);
}
